import { useNavigate } from 'react-router-dom';
import styled, {css } from 'styled-components';
import moment from 'moment';

const styles = css`

display: flex;
flex-direction: column;
width: 100%;
padding: 5px;

> .list {
  border-radius: 3px;
  padding: 5px;
  padding-top: 7px;
  padding-bottom: 7px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  border-bottom: 1px solid #dddddd;
  &:hover {
    cursor: pointer;
    background-color: #dddddd;
  }

  & .list-name {
    display: flex;
    flex-wrap: wrap;
    color: blue;
  }

  & .user-name { 
    display: flex;
    flex-wrap: wrap;  
    font-size: 0.80em; 
    font-weight: bold;
  }

  & .list-date {
    display: flex;
    flex-wrap: wrap;
    font-size: 0.80em;
    padding-left: 5px;
  }

  & .item-count {
    display: flex;
    flex-wrap: wrap;
    font-size: 0.80em; 
    display: flex;
    gap: 5px;
    
  }
}
> .add-list {
  padding-top: 10px;
  justify-self: flex-start;
}
`;
const ListPanel = styled(({ className, group, onSelectList }) => {
  const navigate = useNavigate();
  const nextEvent = group.events.find(event => moment(event.date) >= moment());

  const List = ({ list, onSelectList }) => {
    list.eventDate = '';
    if (nextEvent) {
      if (nextEvent.recipients.find(user => user._id === list.user._id)) {
        list.eventDate = nextEvent.date;
        list.eventName = nextEvent.name;
      }
    }
    return (
      <div className='list' onClick={() => onSelectList(list)}>
        <div>
          <div className='list-name'>
            {list.name}
          </div>
          <div className='list-date'>
            {list.eventName ?? ''}
          </div>
          <div className='list-date'>
            {list.eventDate ? moment(list.eventDate).format('ddd MMM DD YYYY') : ''}
          </div>
        </div>
        <div>
          <div className='user-name'>
            {`${list.user.firstname} ${list.user.lastname}`}
          </div>
          <div className='item-count'>
            <span>{list.itemCount}</span>
            <span>{`Item${list.itemCount !== 1 ? 's' : ''}`}</span>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div className={className}>
      {group.lists.map((list, i) =>
        <List
          key={i}
          list={list}
          onSelectList={onSelectList}
        />)}
      <div className='add-list'>
        <button className='primary'
          onClick={() => navigate('/lists/new', { state: { group } })} >
          Add A New List
        </button>
      </div>
    </div>
  )
})`${styles}`;

export default ListPanel;